module.exports = __webpack_public_path__ + "img/066.16658b58.jpg";